import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import {
  AuditLogFilters,
  AuditLogListResponse,
} from '../../../Interfaces/api/backoffice/audit-log.interface';
import { AuditLog } from '../../../Models/backoffice/audit-log.model';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private readonly _apiService = inject(ApiService);

  listRequest(
    filters: AuditLogFilters,
    page: number,
    pageSize: number,
  ): TypedResourceRequest<LaravelDefaultResponse<AuditLogListResponse>> {
    return this._apiService.get<LaravelDefaultResponse<AuditLogListResponse>>(
      endpoints.backoffice.auditLogs,
      { params: this._params(filters, page, pageSize), skipLoading: true, skipError: true },
    );
  }

  toEntries(response: LaravelDefaultResponse<AuditLogListResponse> | undefined): AuditLog[] {
    return (response?.data?.audit_logs ?? []).map((row) => new AuditLog(row));
  }

  toTotal(response: LaravelDefaultResponse<AuditLogListResponse> | undefined): number {
    return response?.data?.total ?? 0;
  }

  toActions(response: LaravelDefaultResponse<AuditLogListResponse> | undefined): string[] {
    return response?.data?.facets?.actions ?? [];
  }

  toEntityTypes(response: LaravelDefaultResponse<AuditLogListResponse> | undefined): string[] {
    return response?.data?.facets?.entity_types ?? [];
  }

  private _params(
    filters: AuditLogFilters,
    page: number,
    pageSize: number,
  ): Record<string, string | number> {
    const params: Record<string, string | number> = { page, pageSize };

    for (const [key, value] of Object.entries(filters)) {
      if (value !== '') {
        params[key] = String(value);
      }
    }

    return params;
  }
}
